import type { SearchParams, SearchTypes } from './utils/types.private';

export const API_URL = {
  base: '/api/user-details',
  details: '/details/',
  search: '/search/',
};

export const SEARCH_PARAMS: Record<SearchParams, SearchParams> = {
  search: 'search',
  includedGroups: 'includedGroups',
  id: 'id',
};

const translationJoiner = (...path: string[]): string =>
  ['userDetails', ...path].join('.').replace(/\.{2,}/g, '.');

const translationReducer = <T extends readonly string[]>(
  keyList: T,
  basePrefix?: string,
): Record<T[number], string> => {
  return keyList.reduce(
    (list, key) => {
      const typedKey = key as T[number];
      if (basePrefix) {
        list[typedKey] = translationJoiner(basePrefix, key);
      } else {
        list[typedKey] = translationJoiner(key);
      }
      return list;
    },
    {} as Record<T[number], string>,
  );
};

const atomicTranslationKeys = [
  'user',
  'group',
  'missing',
  'userDetail',
  'groupDetailSingle',
  'groupDetailNonSingle',
  'loading',
] as const;
export const userSearchKeys: SearchTypes[] = ['all', 'user', 'group', 'none'];
const userSearchBase = 'userSearch.placeholder',
  pickedUsersBase = 'pickedUsers',
  pickedUsersKeys = ['buttonAriaLabel'] as const,
  errorBase = 'error',
  errorKeys = ['requestError'] as const,
  avatarDisplayBase = 'avatarDisplayList',
  avatarDisplayKeys = ['show', 'hide'] as const;

export const TRANSLATION_KEYS = {
  ATOMIC: translationReducer(atomicTranslationKeys),
  SEARCH: translationReducer(userSearchKeys, userSearchBase),
  PICKED: translationReducer(pickedUsersKeys, pickedUsersBase),
  ERRORS: translationReducer(errorKeys, errorBase),
  AVATAR_DISPLAY_LIST: translationReducer(avatarDisplayKeys, avatarDisplayBase),
};

export const PICKED_HEIGHT_TO_NAME_RATIO = 2.7;
export const BASE_FONT_SIZE = '1em';
export const BASE_LINE_HEIGHT_SIZE = `${PICKED_HEIGHT_TO_NAME_RATIO * 1}em`;
export const AVATAR_BASE_SIZE = '2em';
export const AVATAR_TO_NAME_RATIO = 2;
export const DEFAULT_AVATAR_COLOR = '#D3D3D3';
export const AVATAR_PLACEHOLDER_TEXT = '?';
